import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { SharedHero } from '@hover/shared-components';
import {
  Layout,
  NewsLetterBar,
  UtilityMenuBanner,
} from '../../v2/components/common';

import {
  CaseStudy,
  Customers,
  ExploreMore,
  Info,
  TransformBusiness,
} from '../../v2/components/pros-restoration';
import { URLS } from '../../v2/constants';
import { usePageViewTracking } from '../../utils/trackPageView';

const ProsRestoration: React.FC = () => {
  usePageViewTracking('restoration');
  return (
    <Layout
      title="Exterior Home Improvement Software For Restoration Pros"
      description="Respond to storms faster and serve your customers more efficiently. HOVER is revolutionizing the restoration and claims process."
      buttonType="SCHEDULE_A_DEMO"
      bannerElement={<UtilityMenuBanner />}
    >
      <SharedHero
        heading="Through the storm and beyond."
        body="Shaping the workflow for the modern restoration professional."
        chatWithUsLink={URLS.restoration.chatWithUs}
        desktopImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            src="../../v2/assets/images/pros_restoration_hero_desktop.png"
            alt="pros restoration hero"
            objectFit="cover"
          />
        }
        mobileAndTabletImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            src="../../v2/assets/images/pros_restoration_hero_tablet.png"
            alt="pros restoration hero"
            objectFit="contain"
          />
        }
        page="restoration"
      />
      <Info />
      <CaseStudy />
      <Customers />
      <TransformBusiness />
      <ExploreMore />
      <NewsLetterBar showForm showViewJobs={false} />
    </Layout>
  );
};

export default ProsRestoration;
